import React, { useEffect, useState } from 'react'

// Import Highcharts
import Highcharts from "highcharts";
import HCMore from "highcharts/highcharts-more";
import solidGauge from "highcharts/modules/solid-gauge";
import HighchartsReact from "highcharts-react-official";

HCMore(Highcharts);
solidGauge(Highcharts);


const DonutChart = (props) => {
    const chartContainerStyle = {
        maxWidth: '100px', // Set the desired maximum width
        maxHeight: props?.data?.position === 'top' ? '100px' : '60px', // Set the desired maximum height based on the condition
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      };
    
    let labelText = ''
    if (props.data.text) {
        labelText = "</br><span className='fulll'>" + props.data.text + "</span>";
    }
    const [options, setOptions] = useState({});

    useEffect(() => {

        if (Object.keys(props.data).length > 0) {
            setOptions({
                chart: {
                    type: 'solidgauge',
                    margin: [0, 0, 0, 0],
                    spacingTop: 0,
                    spacingBottom: 0,
                    spacingLeft: 0,
                    spacingRight: 0
                },
                title: {
                    text: ''
                },
                tooltip: {
                    enabled: false
                },
                pane: {
                    startAngle: 0,
                    endAngle: 360,
                    clip: false,
                    background: [{
                        outerRadius: '100%',
                        innerRadius: '75%',
                        borderWidth: 0,
                        backgroundColor: props.data.bgcolor
                    }]
                },

                yAxis: {
                    min: 0,
                    max:100,
                    lineWidth: 0,
                    tickPositions: []
                },
                credits: {
                    enabled: false
                },
                plotOptions: {
                    solidgauge: {
                        dataLabels: {
                            enabled: true,
                            format: props.data.isDisplayVal ?  labelText : labelText,
                            verticalAlign: 'middle',
                            borderWidth: 0,
                            useHTML: true
                        },
                    }
                },
                series: [{
                    data: [{
                        color: '#243976',
                        radius: '100%',
                        innerRadius: '75%',
                        y: parseInt(props.data.value), //parseInt($(this).data('value')),

                    }]
                }]
            })
        }

    }, [props]);

    return (
        <HighchartsReact
            options={options}
            highcharts={Highcharts}
            containerProps={{ className: 'custom-circle-progress label-center', style:chartContainerStyle }}
        />
    )
}

export default DonutChart
